export enum PublisherFormType {
    add = 'ADD',
    create = 'CREATE',
    afterFind = 'AFTER_FIND',
}
